import React, { createContext, useContext, useMemo, useState } from 'react';

/** UI-only state shared between the top bar (App) and the page sidebar. */
interface ShellState {
  /** Mobile navigation drawer. */
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
  /** Whether the current page renders a sidebar (shows the menu button on mobile). */
  hasSidebar: boolean;
  setHasSidebar: (value: boolean) => void;
  /** Hide the top bar while a full-screen loading / greeting screen is shown. */
  chromeHidden: boolean;
  setChromeHidden: (value: boolean) => void;
}

const ShellContext = createContext<ShellState | null>(null);

export const ShellProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [hasSidebar, setHasSidebar] = useState(false);
  const [chromeHidden, setChromeHidden] = useState(false);

  const value = useMemo(
    () => ({ navOpen, setNavOpen, hasSidebar, setHasSidebar, chromeHidden, setChromeHidden }),
    [navOpen, hasSidebar, chromeHidden],
  );

  return <ShellContext.Provider value={value}>{children}</ShellContext.Provider>;
};

const noop = () => {};
const FALLBACK: ShellState = {
  navOpen: false, setNavOpen: noop, hasSidebar: false, setHasSidebar: noop, chromeHidden: false, setChromeHidden: noop,
};

export const useShell = () => useContext(ShellContext) ?? FALLBACK;
